import { Controller } from "stimulus";
import { EventCurrencyChanged, EventPriceChanged } from "../events";
import { getActiveCurrency } from "../util/currency";

export default class extends Controller {
  static targets = ["postMessage", "coinId", "currency", "form", "transactionType", "balance"]

  connect() {
    window.addEventListener(EventCurrencyChanged, e => this._updateCurrency());
  }

  updateCoinIdValue() {
    this.coinIdTarget.value = event.currentTarget.dataset.coinId;
  }

  updateTransactionType() {
    this.transactionTypeTarget.value = event.currentTarget.dataset.type;
  }

  onPostSuccess(e) {
    let [data, status, xhr] = e.detail;
    const successResponse = JSON.parse(xhr.response);


    this._clearFormErrors();
    this.postMessageTarget.classList.add("text-primary");
    this.postMessageTarget.innerHTML = successResponse.message;
    this._updateBalanceBtc(successResponse.balance_btc);
  }

  onPostError(e) {
    let [data, status, xhr] = e.detail;

    const errors = JSON.parse(xhr.response);
    this._renderFormErrors(errors);
  }

  _updateBalanceBtc(balance_btc) {
    this.balanceTarget.dataset.priceBtc = balance_btc;

    this.element.dispatchEvent(
      new CustomEvent(EventPriceChanged, {
        bubbles: true,
        detail: {
          currencyCode: getActiveCurrency()
        }
      })
    );
  }

  _updateCurrency() {
    this.currencyTarget.value = getActiveCurrency();
  }

  _renderFormErrors(errors) {
    const formEl = this.formTarget;
    const model = formEl.getAttribute("data-model");

    for (const [field, messages] of Object.entries(errors)) {
      const input = formEl.querySelector('input[name="' + model + '[' + field + ']"]');
      input.classList.add("is-invalid");
      input.closest('.form-group').querySelector('.text-danger').innerHTML = messages.join(" & ");
    }

    this.postMessageTarget.innerHTML = "";
  }

  _clearFormErrors() {
    const formEl = this.formTarget;
    formEl.querySelectorAll("input").forEach(inputEl => {
      inputEl.classList.remove("is-invalid");
    })
    formEl.querySelectorAll(".text-danger").forEach(node => {
      node.innerHTML = "";
    })
  }
}
